var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showSuccess
    ? _c("div", { staticClass: "my-toast" }, [
        _c("div", { staticClass: "success-toast" }, [
          _c("img", {
            attrs: {
              src: require("../../image/global/toast-success.png"),
              alt: "",
            },
          }),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.msg))]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }